import PersonChallenge from './PersonChallenge';

export default PersonChallenge;
